// frontend/src/App.js
import React, { Suspense, lazy } from 'react';
import './styles/design-system.css';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import AdminRoute from './components/AdminRoute';
import { Routes, Route } from 'react-router-dom';

const LoginPage = lazy(() => import('./components/LoginPage'));
const EmbedChatPage = lazy(() => import('./components/EmbedChatPage'));
const WidgetAdminPage = lazy(() => import('./components/WidgetAdminPage'));

// External redirect component - bypasses React Router to let backend serve the page
const ExternalRedirect = ({ to }) => {
  React.useEffect(() => {
    window.location.href = to;
  }, [to]);
  return <div className="loading-overlay"><div className="app-loader" /><p>Loading…</p></div>;
};

function App() {
  return (
    <AuthProvider>
      <Suspense fallback={<div className="loading-overlay"><div className="app-loader" /><p>Loading…</p></div>}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* Root redirects to widget-demo (public, served by backend) */}
          <Route path="/" element={<ExternalRedirect to="/widget-demo.html" />} />
          {/* Embed route - no auth required */}
          <Route path="/embed/:clientId" element={<EmbedChatPage />} />
          <Route path="/embed" element={<EmbedChatPage />} />
          {/* Main widget admin page */}
          <Route path="/widget-admin" element={<AdminRoute />}>
            <Route index element={<WidgetAdminPage />} />
          </Route>
          <Route path="*" element={<ExternalRedirect to="/widget-demo.html" />} />
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}

export default App;
